// extracted by mini-css-extract-plugin
export default {"faq":"_3ScC5ULo","areYouACreative":"_1YmjpXEM","getStarted":"rsQ7clJY","socialTrust":"_2_r-zRUn","avatarStack":"_30lYDy-F"};